import React from 'react'

export const IconCircleX = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 24.4C19.296 24.4 24.4 19.296 24.4 13C24.4 6.70395 19.296 1.6 13 1.6C6.70395 1.6 1.6 6.70395 1.6 13C1.6 19.296 6.70395 24.4 13 24.4ZM13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26ZM17.5659 8.43451C17.8783 8.74693 17.8783 9.25346 17.5659 9.56588L14.1316 13.0002L17.5659 16.4345C17.8783 16.7469 17.8783 17.2535 17.5659 17.5659C17.2535 17.8783 16.7469 17.8783 16.4345 17.5659L13.0002 14.1316L9.56588 17.5659C9.25346 17.8783 8.74693 17.8783 8.43451 17.5659C8.12209 17.2535 8.12209 16.7469 8.43451 16.4345L11.8688 13.0002L8.43451 9.56588C8.12209 9.25346 8.12209 8.74693 8.43451 8.43451C8.74693 8.12209 9.25346 8.12209 9.56588 8.43451L13.0002 11.8688L16.4345 8.43451C16.7469 8.12209 17.2535 8.12209 17.5659 8.43451Z"
      fill="currentColor"
    />
  </svg>
)
